<div class="app-dialog-header modal-header ng-scope" [ngClass]="customClass">
    <button *ngIf="showClose" class="app-dialog-close close ng-scope" aria-label="Close"
        (click)="handleClose()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="app-dialog-title modal-title">{{title}}
        <span class="dialog-sub-heading ng-binding ng-scope" name="wm-BindVariable-sub-heading" *ngIf="subheading">{{subheading}}</span>
    </h4>
    <div class="wm-dialog-header-action ng-scope">
        <i *ngIf="helpLink" [title]="helpTitle" class="wm-icon wms wms-help"></i>
        <a *ngIf="helpLink" target="_blank" [href]="helpLink" class="ng-binding">Help</a>
    </div>
</div>